import { Spinner } from 'reactstrap';

// Velo con spinner sobre la tabla/calendario mientras se recargan los datos.
// El contenedor padre debe tener la clase `dv2-loading-wrap`.
const DashboardLoadingOverlay = ({ show }: { show: boolean }) =>
  show ? (
    <div className="dv2-loading-overlay" role="status" aria-label="Cargando">
      <Spinner color="success" />
      <span>Cargando…</span>
    </div>
  ) : null;

export default DashboardLoadingOverlay;
